import React from 'react';

import PropTypes from 'prop-types';
import {Form, FormikProps} from 'formik';
import {Box, Grid} from '@material-ui/core';
import {CallMade} from '@material-ui/icons';

import {FieldShape} from 'commons/shapes';
import {ConsigneeData, InferPropTypes} from 'commons/types/Types';
import {EfeButtonPrimary, EfeFormSection, EfeSupportMessage} from 'components';

PersonalInfoInnerForm.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

function PersonalInfoInnerForm(
    props: InferPropTypes<typeof PersonalInfoInnerForm.propTypes & FormikProps<ConsigneeData>>
) {
    const {values, errors, fields, isSubmitting, setFieldValue} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <Form noValidate>
            {fields && fields.length > 0 && (
                <Box m={2}>
                    <EfeSupportMessage />
                    <EfeFormSection
                        fields={fields}
                        values={values}
                        errors={errors}
                        setFieldValue={setFieldValue}
                    />
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            )}
        </Form>
    );
}

export default PersonalInfoInnerForm;
